//react-components
import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import _ from "lodash";

//Custom UI components
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";

// Utils
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";
import { getFileExtension } from "../Utils/FileUtils";
import { checkIfNumber, isValidEmail } from "../Utils/Validations";

//Constants
import {
  defaultObjForAddOrUpdateUser,
  DEFAULT_USER_SELECTION,
  PROFILE_PHOTO_FILE_SIZE,
} from "./Constants";
import { AUDIT_TYPE } from "../AuditTrail/Constants";

//Strings
import { Strings } from "../Translations/i18n";

//Styles
import "./AddOrUpdateUser.scss";

//Assets
import cameraImage from "../Assets/images/ic_photograph.svg";
import ProfileImage from "../Assets/images/ic_header_default_user.svg";

class AddOrUpdateUser extends Component {
  constructor(props) {
    super(props);
    //Create user object base on values present in user reducer
    let user =
      JSON.stringify(this.props.selectedUser) !==
      JSON.stringify(defaultObjForAddOrUpdateUser)
        ? this.props.selectedUser
        : defaultObjForAddOrUpdateUser;

    this.state = {
      user: user,
      cachedUser: user,
      avatar: null,
      disableInput:
        JSON.stringify(this.props.selectedUser) !==
        JSON.stringify(defaultObjForAddOrUpdateUser)
          ? true
          : false,
      disableSave: true,
      deactivateUserModal: false,
      validEmail: true,
      validFile: true,
      validSize: true,
      validExtension: true,
      validFirstName: true,
      validLastName: true,
      file: null,
      profilePicUrl: null,
      showLoadingModal: false,
    };
  }

  componentDidMount() {
    if (this.state.cachedUser.username) {
      this.props.getProfilePhoto(this.state.cachedUser.username);
    }
    this.setState({
      showLoadingModal: true,
      profilePicUrl: this.props.profilePicUrl,
    });

    if (this.props.profilePicUrl === null) {
      this.setState({ showLoadingModal: false });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    //handled change in reducer
    if (nextProps.selectedUser !== prevState.user)
      return {
        profilePicUrl:
          JSON.stringify(nextProps.selectedUser) !==
          JSON.stringify(defaultObjForAddOrUpdateUser)
            ? nextProps.profilePicUrl
            : null,
        user:
          JSON.stringify(nextProps.selectedUser) !==
          JSON.stringify(defaultObjForAddOrUpdateUser)
            ? nextProps.selectedUser
            : defaultObjForAddOrUpdateUser,
        disableInput:
          JSON.stringify(nextProps.selectedUser) !==
          JSON.stringify(defaultObjForAddOrUpdateUser)
            ? true
            : false,
        cachedUser:
          JSON.stringify(nextProps.selectedUser) !==
          JSON.stringify(defaultObjForAddOrUpdateUser)
            ? nextProps.selectedUser
            : defaultObjForAddOrUpdateUser,
        //To display preview of photo
        avatar:
          JSON.stringify(nextProps.selectedUser) !==
          JSON.stringify(defaultObjForAddOrUpdateUser)
            ? prevState.avatar
            : defaultObjForAddOrUpdateUser.photo,
      };
    else {
      return { profilePicUrl: nextProps.profilePicUrl };
    }
  }
  //Added check for if fields are empty then disable save
  checkForDisableSave = () => {
    let disableSave = true;
    if (
      this.state.cachedUser.firstName.trim() !== "" &&
      this.state.cachedUser.lastName.trim() !== "" &&
      this.state.cachedUser.username.trim() !== "" &&
      this.state.cachedUser.phone.length === 9 &&
      this.state.cachedUser.email.trim() !== "" &&
      this.state.validFile &&
      this.state.cachedUser.role !== DEFAULT_USER_SELECTION
    ) {
      disableSave = false;
    }

    this.setState({
      disableSave: disableSave,
    });
  };

  //Handle Changed first name of user
  onChangeFirstName = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          firstName: e.target.value,
        },
      },
      this.checkForDisableSave
    );
  };

  //Handle Changed last name of user
  onChangeLastName = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          lastName: e.target.value,
        },
      },
      this.checkForDisableSave
    );
  };
  //Handle Changed username of user
  onChangeUsername = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          username: e.target.value,
        },
      },
      this.checkForDisableSave
    );
  };
  //Handle Changed kind/role of user
  onChangeRole = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          role: e.target.value,
          firstName: this.state.cachedUser.firstName,
          lastName: this.state.cachedUser.lastName,
          username: this.state.cachedUser.username,
          email: this.state.cachedUser.email,
          phone: this.state.cachedUser.phone,
        },
      },
      this.checkForDisableSave
    );
  };

  onChangeReportingTo = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          reportingTo:
            e.target.value === DEFAULT_USER_SELECTION ? "" : e.target.value,
        },
      },
      this.checkForDisableSave
    );
  };

  //Handle Changed email of user
  onChangeEmail = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          email: e.target.value,
        },
      },
      this.checkForDisableSave
    );
  };
  //Handle Changed phone no. of user
  onChangePhone = (e) => {
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          phone: e.target.value,
        },
      },
      this.checkForDisableSave
    );
  };
  //Handle onClcik of edit button
  onEditUser = () => {
    this.setState({
      disableInput: false,
    });
  };
  //Handle onClcik of save button
  onSaveClick = () => {
    let validEmail = true;
    let validFirstName = true;
    let validLastName = true;
    let firstName = this.state.cachedUser.firstName.trim();
    let lastName = this.state.cachedUser.lastName.trim();

    if (!isValidEmail(this.state.cachedUser.email)) validEmail = false;
    this.setState({ validEmail: validEmail });
    if (
      firstName !== "" &&
      lastName !== "" &&
      this.state.cachedUser.username.trim() !== "" &&
      this.state.cachedUser.phone.length === 9 &&
      // this.state.cachedUser.photo !== "defaultImage" &&
      this.state.cachedUser.email.trim() !== "" &&
      validEmail &&
      validFirstName &&
      validLastName
    ) {
      if (this.state.user.username !== "") {
        this.props.handleUpdateUser(
          this.state.cachedUser,
          this.state.file,
          this.state.avatar
        );
      } else {
        this.props.handleCreateUser(this.state.cachedUser, this.state.file);
      }
    }
  };
  onDeactivateClick = () => {
    this.setState({ deactivateUserModal: true });
  };
  onYesClick = () => {
    this.props.handleDeactivateUser(this.state.cachedUser);
  };
  onNoClick = () => {
    this.setState({ deactivateUserModal: false });
  };
  validateNumberField = (event) => {
    if (!checkIfNumber(event) || event.shiftKey) {
      event.preventDefault();
    }
  };

  handleUploadPhoto = (event) => {
    let refThis = this;
    let file = event.target.files[0];
    let validFile = true;
    let validExtension = true;
    let validSize = true;

    if (file) {
      let fileExtension = getFileExtension(file);
      if (
        !_.includes(
          APPLICATION_CONFIGURATIONS.fileConfigurations.allowedImageExtensions,
          fileExtension
        )
      ) {
        validFile = false;
        validExtension = false;
      }
      if (file.size > PROFILE_PHOTO_FILE_SIZE) {
        validFile = false;
        validSize = false;
      }
      if (validFile) {
        let reader = new FileReader();
        reader.onloadend = () => {
          refThis.setState({
            cachedUser: {
              ...refThis.state.cachedUser,
            },
            avatar: reader.result,
          });
        };
        reader.readAsDataURL(file);
      }
    }
    this.setState({ validFile, validExtension, validSize });
    if (this.state.validFile) {
      this.setState({ file });
    }
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
        },
      },
      this.checkForDisableSave
    );
  };

  /**
   * Set username on basis of firstname and lastname
   */
  setUsernameToDefault = () => {
    let uname;
    //Check if username is not exist and  firstname and lastname is not exist
    //then user firstname.lastname as username
    if (this.state.cachedUser.username.trim().length === 0) {
      if (
        this.state.cachedUser.firstName.trim().length !== 0 &&
        this.state.cachedUser.lastName.trim().length !== 0
      )
        uname =
          this.state.cachedUser.firstName.trim().toLowerCase() +
          "." +
          this.state.cachedUser.lastName.trim().toLowerCase();
      else uname = this.state.cachedUser.username;
    } else uname = this.state.cachedUser.username;
    this.setState(
      {
        cachedUser: {
          ...this.state.cachedUser,
          username: uname,
        },
      },
      this.checkForDisableSave
    );
  };

  render() {
    return (
      <div>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />
        <Row md={12} className="addOrUpdateUserMainPanel">
          <Row className="mainHeaderApplication addOrUpdateUserHeader">
            {JSON.stringify(this.props.selectedUser) !==
            JSON.stringify(defaultObjForAddOrUpdateUser) ? (
              <div className="addOrUpdateUserPanel d-flex justify-content-between">
                <div>{Strings(this.props.title)}</div>
                <div>
                  <Button
                    variant=""
                    className="addOrUpdateUserTopButtons addOrUpdateUserTopButtonAlign pull-right mx-1"
                    onClick={this.onEditUser}
                    disabled={!this.state.disableInput}
                  >
                    <i className="fa fa-pencil addOrUpdateUserIcon" />
                    {Strings("edit")}
                  </Button>

                  <Button
                    variant=""
                    className="addOrUpdateUserTopButtons addOrUpdateUserTopButtonAlign pull-right  mx-1"
                    onClick={() => {
                      this.props.redirectToAudit(AUDIT_TYPE.ADMIN_AUDIT);
                    }}
                  >
                    {Strings("ADMIN_AUDIT")}
                  </Button>
                </div>
              </div>
            ) : (
              Strings("addUser")
            )}

            <Row md={12} className="positionAddOrUpdateUserMainPanel">
              <Col md={6} className="noPadding positionInnerPanel">
                <div className="parentOfImages">
                  <img
                    src={
                      this.state.profilePicUrl === null || this.state.avatar
                        ? this.state.avatar
                          ? this.state.avatar
                          : ProfileImage
                        : this.props.profilePicUrl
                    }
                    className="addOrUpdateUserImage"
                    alt=""
                  />
                  <label htmlFor="uploadPhoto" className="browse-button ">
                    <img
                      src={cameraImage}
                      className={
                        "addOrUpdateUserImageCamera " +
                        (this.state.disableInput ? "disabled" : "enabled")
                      }
                      alt=""
                    />
                  </label>
                </div>

                <Form.Control
                  type="file"
                  id="uploadPhoto"
                  onChange={this.handleUploadPhoto}
                  accept="image/png,image/jpeg,image/jpg"
                  style={{ display: "none" }}
                  disabled={this.state.disableInput}
                />

                <Row
                  md={12}
                  className="subHeaderApplication addOrUpdateUserFontSize"
                >
                  {this.state.validFirstName === false && (
                    <div className="errors">
                      {Strings("errorInvalidFirstName")}
                    </div>
                  )}
                  {this.state.validLastName === false && (
                    <div className="errors">
                      {Strings("errorInvalidLastName")}
                    </div>
                  )}
                  {this.state.validFile ? (
                    this.state.validEmail ? (
                      this.props.errorMessage !== "" && (
                        <div className="errors">{this.props.errorMessage}</div>
                      )
                    ) : (
                      <div className="errors">
                        {Strings("errorInvalidEmail")}
                      </div>
                    )
                  ) : (
                    (!this.state.validSize && (
                      <div className="errors">
                        {Strings("errorInvalidSizeAvatar")}
                      </div>
                    )) ||
                    (!this.state.validExtension && (
                      <div className="errors">
                        {Strings("errorImageExtension")}
                      </div>
                    ))
                  )}
                  <Col md={6} className="addOrUpdateUserPaddingLeft0">
                    {Strings("fullName")}
                    <span className="mandatoryFields">*</span>
                    <Row md={12} className="addOrUpdateUserExtraMargin">
                      <Col md={6} className="addOrUpdateUserFirstName">
                        <Form.Control
                          id="firstName"
                          type="text"
                          className="noMargin"
                          placeholder="Primer Nombre"
                          onChange={this.onChangeFirstName}
                          value={this.state.cachedUser.firstName}
                          disabled={this.state.disableInput}
                        />
                      </Col>

                      <Col md={6} className="noPadding">
                        <Form.Control
                          id="lastName"
                          type="text"
                          className="noMargin"
                          placeholder="Primer Apellido"
                          onChange={this.onChangeLastName}
                          value={this.state.cachedUser.lastName}
                          disabled={this.state.disableInput}
                        />
                      </Col>
                    </Row>
                    {Strings("user")}
                    <span className="mandatoryFields">*</span>
                    <Row className="addOrUpdateUserExtraMargin">
                      <Form.Control
                        id="user"
                        type="text"
                        className="noMargin"
                        placeholder="Usuario"
                        onChange={this.onChangeUsername}
                        onFocus={() => {
                          this.setUsernameToDefault();
                        }}
                        value={this.state.cachedUser.username}
                        disabled={
                          this.state.disableInput
                            ? this.state.disableInput
                            : this.state.user.username !== ""
                            ? true
                            : false
                        }
                      />
                    </Row>
                    {Strings("role")}
                    <span className="mandatoryFields">*</span>

                    <Form.Group
                      controlId="Form.ControlsSelect"
                      className="addOrUpdateUserExtraMargin"
                    >
                      <Form.Select
                        className="form-control"
                        onChange={this.onChangeRole}
                        componentClass="select"
                        value={this.state.cachedUser.role}
                        disabled={
                          JSON.stringify(this.props.selectedUser) !==
                            JSON.stringify(defaultObjForAddOrUpdateUser) ||
                          this.state.user.username !== ""
                        }
                      >
                        {this.props.userRoles &&
                          this.props.userRoles.map((singleUser) => {
                            return (
                              <option
                                key={singleUser.role}
                                value={singleUser.role}
                              >
                                {Strings(singleUser.role)}
                              </option>
                            );
                          })}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6} className="addOrUpdateUserPaddingRight0">
                    {Strings("email")}
                    <span className="mandatoryFields">*</span>
                    <Row className="addOrUpdateUserExtraMargin">
                      <Form.Control
                        id="email"
                        type="text"
                        className="noMargin"
                        placeholder="Correo electrónico"
                        onChange={this.onChangeEmail}
                        value={this.state.cachedUser.email}
                        disabled={this.state.disableInput}
                      />
                    </Row>
                    {Strings("phoneNumber")}
                    <span className="mandatoryFields">*</span>
                    <Row className="addOrUpdateUserExtraMargin">
                      <Form.Control
                        id="phone"
                        type="text"
                        className="noMargin"
                        placeholder="Número de Teléfono"
                        onChange={this.onChangePhone}
                        maxLength={9}
                        onKeyDown={this.validateNumberField}
                        value={this.state.cachedUser.phone}
                        disabled={this.state.disableInput}
                      />
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr className="addOrUpdateUserChangeHrMargin" />

            <div className="d-flex justify-content-between">
              <div>
                <Button
                  variant=""
                  className="buttonBorder pull-left  mx-1"
                  onClick={this.props.onBackClick}
                >
                  {Strings("back")}
                </Button>
              </div>
              {!this.state.disableInput ? (
                <div>
                  <Button
                    variant=""
                    className="buttonBackground pull-right mx-1"
                    onClick={this.onSaveClick}
                    disabled={this.state.disableSave}
                  >
                    {Strings("save")}
                  </Button>
                </div>
              ) : null}
            </div>
          </Row>
        </Row>
      </div>
    );
  }
}
export default AddOrUpdateUser;
